import { useCallback, useEffect, useState } from "react";
import { LayoutGrid, Trophy, ImageIcon, Users, Tag, Settings } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AdminOverview } from "../components/admin/AdminOverview";
import { AdminContests } from "../components/admin/AdminContests";
import { AdminPhotos } from "../components/admin/AdminPhotos";
import { AdminUsers } from "../components/admin/AdminUsers";
import { AdminPricing } from "../components/admin/AdminPricing";
import { AdminSettings } from "../components/admin/AdminSettings";

const TABS = [
  { id: "overview", label: "Visão geral", icon: LayoutGrid },
  { id: "contests", label: "Concursos", icon: Trophy },
  { id: "moderation", label: "Moderação", icon: ImageIcon },
  { id: "users", label: "Usuários", icon: Users },
  { id: "pricing", label: "Preços", icon: Tag },
  { id: "settings", label: "Configurações", icon: Settings },
];

export default function Admin() {
  const { refreshSettings, settings: pub } = useAuth();
  const [tab, setTab] = useState("overview");
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setSettings(r.data));
  }, []);

  const save = useCallback(async (patch) => {
    try {
      const { data } = await api.put("/admin/settings", { ...settings, ...patch });
      setSettings(data);
      await refreshSettings();
      toast.success("Configurações salvas");
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, [settings, refreshSettings]);

  return (
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-testid="owner-admin-panel">
      <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-lime-300">// Painel do proprietário</p>
      <h1 className="mt-2 font-display text-5xl font-black uppercase">Centro de comando</h1>
      <Tabs value={tab} onValueChange={setTab} className="mt-10">
        <TabsList className="h-auto flex-wrap justify-start gap-1 bg-white/5 p-1">
          {TABS.map((t) => (
            <TabsTrigger key={t.id} value={t.id} data-testid={`admin-tab-${t.id}`} className="gap-2 data-[state=active]:bg-cyan-400 data-[state=active]:text-black">
              <t.icon className="h-4 w-4" /> {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="overview" className="mt-8"><AdminOverview onGo={setTab} /></TabsContent>
        <TabsContent value="contests" className="mt-8"><AdminContests /></TabsContent>
        <TabsContent value="moderation" className="mt-8"><AdminPhotos /></TabsContent>
        <TabsContent value="users" className="mt-8"><AdminUsers /></TabsContent>
        <TabsContent value="pricing" className="mt-8">{settings && <AdminPricing settings={settings} onSave={save} />}</TabsContent>
        <TabsContent value="settings" className="mt-8">{settings && <AdminSettings settings={settings} onSave={save} mpConfigured={pub?.mercadopago_available || false} />}</TabsContent>
      </Tabs>
    </div>
  );
}
